import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * src/index.css @theme의 이름 붙은 토큰을 tailwind-merge에 알려 준다.
 * 알려 주지 않으면 text-body-14-m(글자 크기)을 글자 색으로 보고 text-fg-primary와 겹친다고 판단해 하나를 지운다.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'display-48-eb',
        'heading-24-b',
        'heading-20-b',
        'subtitle-18-b',
        'subtitle-16-b',
        'body-16-sb',
        'body-16-m',
        'body-16-r',
        'body-15-sb',
        'body-15-m',
        'body-15-r',
        'body-14-sb',
        'body-14-m',
        'body-14-r',
        'body-13-sb',
        'body-13-r',
        'caption-11-r',
        'button-18-sb',
        'button-16-sb',
        'button-14-sb',
        'button-14-m',
        'button-12-sb',
        'button-10-sb',
      ],
      radius: ['4', '8', '12', '16', '20', '24', '40', 'badge', 'card'],
      shadow: ['100', '500', '800'],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
